<form [signalForm]="configForm" class="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto px-4 py-4">
  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">
      Configuration
    </h3>
    <lib-signal-text-field
      label="Label"
      [formField]="configForm.label" />
    <lib-signal-text-field
      label="Help text"
      placeholder="Shown under the checkbox"
      [formField]="configForm.helpText" />
    <lib-signal-text-field
      label="Link text"
      placeholder="e.g. Terms and Conditions"
      [formField]="configForm.linkText" />
    <lib-signal-text-field
      label="Link URL"
      placeholder="https://example.com/terms"
      [formField]="configForm.linkUrl" />
    <lib-signal-checkbox
      label="Checked by default"
      hint="Automatically filled when the form opens. Respondents can change it."
      [formField]="configForm.defaultValue" />
  </section>
  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">
      Validators
    </h3>
    <lib-signal-checkbox
      label="Required"
      hint="Respondent must check this option"
      [formField]="configForm.required" />
  </section>
</form>
